export default __webpack_public_path__ + "static/media/Foto-22.e38a9d95.png";